import React, { useId, useRef } from 'react';
import { SectionHeader, TeamCard } from '../../molecules';
import { Container, EntryAnimation } from '../../atoms';
export default function TeamSection(param) {
    var title = param.title, subtitle = param.subtitle, team = param.team, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: TeamSection.name,
        className: className
    }, !!(title || subtitle) && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        className: "mb-6 md:mb-8"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center items-center -m-4 md:-m-5"
    }, team.map(function(member, memberIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "member-".concat(id, "-").concat(member.name),
            view: containerRef,
            className: "w-1/2 p-4 md:w-1/4 md:p-5",
            delay: memberIndex / 10
        }, /*#__PURE__*/ React.createElement(TeamCard, member));
    }))));
}

//# sourceMappingURL=TeamSection.js.map